// extracted by mini-css-extract-plugin
export default {"wrapper":"pop-up_wrapper__OQfll","wrapperNoBg":"pop-up_wrapperNoBg__D-PWN"};